import React, { useContext } from 'react';
import { Nav } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import classNames from 'classnames';
// import AppContext from '../../context/Context';
import NavbarDropdown from './NavbarDropdown';
import { CiatAppContext } from '../../../../providers';
import NavbarDropdownSection from './NavbarDropdownSection';

function NavbarTopDropDownMenus() {
  // const {
  //   config: { navbarCollapsed, showBurgerMenu },
  //   setConfig,
  // } = useContext(AppContext);
  const { currentUser } = useContext(CiatAppContext);
  const sections = currentUser.available_sections;

  // const handleDropdownItemClick = () => {
  //   if (navbarCollapsed) {
  //     setConfig('navbarCollapsed', !navbarCollapsed);
  //   }
  //   if (showBurgerMenu) {
  //     setConfig('showBurgerMenu', !showBurgerMenu);
  //   }
  // };
  return (
    <>
      <Nav.Link
        as={NavLink}
        className={classNames('fw-medium', {
          'text-500': true,
          'text-700 mb-0 fw-bold': 'Головна',
          'link-600': true,
        })}
        to="/"
      >
        Головна
      </Nav.Link>
      {sections.map((section) => (
        <NavbarDropdown title={section.label} key={section.name}>
          <NavbarDropdownSection sections={section.children} />
        </NavbarDropdown>
      ))}
      <Nav.Link
        as={NavLink}
        className={classNames('fw-medium', {
          'text-500': true,
          'text-700 mb-0 fw-bold': 'Звіти',
          'link-600': true,
        })}
        to="/"
      >
        Звіти
      </Nav.Link>
    </>
  );
}

export default NavbarTopDropDownMenus;
